import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'

import { ButtonGroup, CardBody } from 'Components/_theme'
import { ShippingAddressForm } from 'Components/ShippingAddressForm/ShippingAddressForm'
import { ShippingAddressFormSchema } from 'Components/ShippingAddressForm/ShippingAddressForm.types'

import {
  E2E_LOST_STOLEN_BUTTON_BACK,
  E2E_LOST_STOLEN_BUTTON_SUBMIT,
} from 'Constants/e2e'

import { LOST_STOLEN_MODAL_SHIPPING_FORM } from '../../LostOrStolenModal.constants'
import {
  LostOrStolenModalShippingFormProps,
  LostOrStolenModalStepsEnum,
} from '../../LostOrStolenModal.types'

export const LostOrStolenModalShippingForm = (
  props: LostOrStolenModalShippingFormProps,
) => {
  const { rental, shippingFormData, onSetCurrentStep } = props
  const [isSubmitting, setIsSubmitting] = useState(false)
  const intl = useIntl()

  const handlePrev = useCallback(() => {
    onSetCurrentStep(LostOrStolenModalStepsEnum.LANDING)
  }, [onSetCurrentStep])

  const handleSubmit = useCallback(
    (data: ShippingAddressFormSchema) => {
      onSetCurrentStep(LostOrStolenModalStepsEnum.SUMMARY, data)
    },
    [onSetCurrentStep],
  )

  return (
    <CardBody>
      <ShippingAddressForm
        defaultValues={shippingFormData}
        formId={LOST_STOLEN_MODAL_SHIPPING_FORM}
        onSetIsSubmitting={setIsSubmitting}
        onSubmit={handleSubmit}
        rental={rental}
      />

      <ButtonGroup
        leftButton={{
          'data-e2e': E2E_LOST_STOLEN_BUTTON_BACK,
          onClick: handlePrev,
          text: intl.formatMessage({ id: 'Back' }),
        }}
        rightButton={{
          'data-e2e': E2E_LOST_STOLEN_BUTTON_SUBMIT,
          disabled: isSubmitting,
          form: LOST_STOLEN_MODAL_SHIPPING_FORM,
          text: intl.formatMessage({ id: 'Next' }),
          type: 'submit',
        }}
      />
    </CardBody>
  )
}
